module.exports = __webpack_public_path__ + "files/80d0b96910d19b1ac47d0098ccca1263.png";